module.exports = __webpack_public_path__ + "static/media/barbell-plate-2000.fa598f99.png";